module.exports = {
    NODE_ENV: '"development"',
    BASE_API: '"http://www.merchant.com"',
    APP_ORIGIN: '"https://wz.com"'
}



//////////////////
// WEBPACK FOOTER
// ./config/dev.env.js
// module id = 200
// module chunks = 103